import './ProfileTabs.css';

const PROFILE_TABS = [
    { id: 'about', label: 'About' },
    // { id: 'posts', label: 'Posts' },
    { id: 'reviews', label: 'Reviews' },
    { id: 'services', label: 'Services' }
];

const CONSOLE_TABS = [
    { id: 'bookings', label: 'Bookings' },
    { id: 'about', label: 'About' },
    { id: 'card-edit', label: 'Card Edit' },
    // { id: 'posts', label: 'Posts' },
    { id: 'reviews', label: 'Reviews' },
    { id: 'courses', label: 'Courses' },
    { id: 'services', label: 'Services' }
];


const ProfileTabs = ({ isConsole, activeTab, onTabChange, isMobile, showCourses = false }) => {

    // Get base tabs
    let baseTabs = isConsole ? CONSOLE_TABS : PROFILE_TABS;
    
    // For profile page, conditionally add Courses tab if user is owner
    if (!isConsole && showCourses) {
        // Insert Courses tab before Services
        const servicesIndex = baseTabs.findIndex(tab => tab.id === 'services');
        if (servicesIndex !== -1) {
            baseTabs = [
                ...baseTabs.slice(0, servicesIndex),
                { id: 'courses', label: 'Courses' },
                ...baseTabs.slice(servicesIndex)
            ];
        } else {
            baseTabs = [...baseTabs, { id: 'courses', label: 'Courses' }];
        }
    }

    // Filter services tab for desktop
    const visibleTabs = baseTabs.filter(tab =>
        tab.id !== 'services' || isMobile
    );

    return (
        <nav className="profile-tabs">
            <div className="profile-tabs__container">
                {visibleTabs.map(tab => (
                    <button
                        key={tab.id}
                        className={`profile-tab ${activeTab === tab.id ? 'profile-tab--active' : ''}`}
                        onClick={() => onTabChange(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
        </nav>
    );
};

export default ProfileTabs;
